module.exports = __webpack_public_path__ + "img/mc-lr-y1.3d77fbca.gif";